export default function SolucoesTecnologicas() {
  return (
    <section className="bg-[#040116] text-white">
      <div className="container mx-auto xl:max-w-6xl py-32 flex items-center justify-between gap-20">
        <article className="w-full text-[48px]">
          <h3 className="leading-14">
            Soluções tecnológicas <br /> de{' '}
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              alta performance
            </span>
          </h3>
        </article>
        <article>
          <p className="text-2xl">
            Alavancamos negócios rumo à eficiência com aplicativos, sistemas e
            plataformas que geram resultados efetivos e impactantes.
          </p>
        </article>
      </div>
    </section>
  )
}
